var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookRounded(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1c6.075 0 11 4.925 11 11 0 5.49-4.023 10.041-9.281 10.866V15.18h2.563L16.77 12h-3.051V9.937c0-.87.426-1.718 1.792-1.718h1.387V5.512s-1.258-.215-2.462-.215c-2.512 0-4.155 1.523-4.155 4.28V12H7.488v3.18h2.793v7.686C5.023 22.041 1 17.49 1 12 1 5.925 5.925 1 12 1z",
    fill: "#121318"
  })));
}

export default SvgFacebookRounded;